// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";
import {appBuilderThemeOtherPropsSchema} from "./appBuilderThemeOther.zod";

export const mantineThemeOverridePropsSchema = z.object({
	focusRing: z
		.union([z.literal("auto"), z.literal("always"), z.literal("never")])
		.optional(),
	scale: z.number().optional(),
	fontSmoothing: z.boolean().optional(),
	white: z.string().optional(),
	black: z.string().optional(),
	primaryColor: z.string().optional(),
	autoContrast: z.boolean().optional(),
	luminanceThreshold: z.number().optional(),
	fontFamily: z.string().optional(),
	fontFamilyMonospace: z.string().optional(),
	defaultRadius: z.union([z.string(), z.number()]).optional(),
	cursorType: z
		.union([z.literal("default"), z.literal("pointer")])
		.optional(),
	respectReducedMotion: z.boolean().optional(),
	activeClassName: z.string().optional(),
	focusClassName: z.string().optional(),
	colors: z.record(z.string(), z.array(z.string())).optional(),
	primaryShade: z
		.union([
			z.number(),
			z.object({
				light: z.number().optional(),
				dark: z.number().optional(),
			}),
		])
		.optional(),
	fontSizes: z.record(z.string(), z.string()).optional(),
	lineHeights: z.record(z.string(), z.string()).optional(),
	fontWeights: z.record(z.string(), z.string()).optional(),
	radius: z.record(z.string(), z.string()).optional(),
	spacing: z.record(z.string(), z.string()).optional(),
	breakpoints: z.record(z.string(), z.string()).optional(),
	shadows: z.record(z.string(), z.string()).optional(),
	headings: z.record(z.string(), z.unknown()).optional(),
	defaultGradient: z
		.object({
			from: z.string().optional(),
			to: z.string().optional(),
			deg: z.number().optional(),
		})
		.optional(),
	components: z.record(z.string(), z.unknown()).optional(),
	other: appBuilderThemeOtherPropsSchema.optional(),
});
